import React from "react";
import moment from 'moment-timezone';
import { withRouter } from 'react-router-dom'
import { Table, Popconfirm, Form, Button, Switch, Icon, Tooltip, Popover, Modal, message, Input } from 'antd';
import { getBlindboxList,   deleteCoupon, putCoupon } from "../../action/goodAction";
import { getPartner } from "../../action/authAction"
import "../category/category.less"
import intl from 'react-intl-universal';
let currency_symbol = sessionStorage.getItem("currency_symbol")


const svgIcon = () => (
    <svg t="1672913087964" class="icon" viewBox="170 80 700 650" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1812" data-spm-anchor-id="a313x.7781069.0.i4" width="21" height="21"><path d="M509.130138 69.272713c-244.199745 0-442.131723 197.966771-442.131723 442.149119 0 244.182348 197.933001 442.11535 442.131723 442.11535 244.182348 0 442.131723-197.933001 442.131723-442.11535C951.262884 267.239484 753.312486 69.272713 509.130138 69.272713M509.130138 909.026432c-219.597417 0-397.621996-178.007183-397.621996-397.6046 0-219.631186 178.024579-397.639392 397.621996-397.639392 219.597417 0 397.620973 178.007183 397.620973 397.639392C906.752134 731.018226 728.727555 909.026432 509.130138 909.026432" fill="#ffffff" p-id="1813" data-spm-anchor-id="a313x.7781069.0.i5" class="selected"></path><path d="M783.062044 521.506515c7.842619 7.823176 7.196912 21.159926-1.426489 29.765931L675.001933 657.925511l-53.135174 53.134151c-8.624425 8.623401-21.976524 9.283434-29.801746 1.441838-7.840572-7.840572-7.196912-21.194718 1.443885-29.800723l51.708686-51.726082L753.277694 522.933003C761.902118 514.308579 775.236821 513.663896 783.062044 521.506515" fill="#515151" p-id="1814"></path><path d="M519.180028 611.988272c-7.824199 7.823176-7.198959 21.159926 1.424442 29.765931l16.152888 16.171308 53.135174 53.150524c8.623401 8.606005 21.977547 9.267061 29.820166 1.425466 7.823176-7.840572 7.18054-21.194718-1.426489-29.800723l-51.744501-51.726082-17.577331-17.561981C540.35735 604.789313 527.021623 604.145653 519.180028 611.988272" fill="#515151" p-id="1815"></path><path d="M330.410734 417.549861l346.138438 0 0 41.72838-346.138438 0 0-41.72838Z" fill="#515151" p-id="1816"></path><path d="M330.410734 527.765055l346.138438 0 0 41.729403-346.138438 0 0-41.729403Z" fill="#515151" p-id="1817"></path><path d="M322.412572 632.087029c-16.744359 0-30.340005-12.518105-30.340005-27.992541l0-213.267245c0-15.474436 13.596669-28.028357 30.340005-28.028357l362.134761 0c16.759709 0 30.340005 12.55392 30.340005 28.028357l0 154.918325 39.050388-39.051411L753.937726 360.607988c0-19.838837-16.1007-35.938514-35.95591-35.938514L288.978089 324.669474c-19.856233 0-35.938514 16.099676-35.938514 35.938514l0 273.66994c0 19.856233 16.08228 35.957957 35.938514 35.957957l247.397576 0-38.129412-38.147832L322.412572 632.088052z" fill="#515151" p-id="1818"></path></svg>
)
const fileIcon = () => (
    <svg t="1672985602944" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1282" width="16" height="16"><path d="M143 398v415h737V398H143z m-80-48c0-17.673 14.327-32 32-32h833c17.673 0 32 14.327 32 32v511c0 17.673-14.327 32-32 32H95c-17.673 0-32-14.327-32-32V350z" fill="#515151" p-id="1283"></path><path d="M296.657 581.044a8 8 0 0 1 0-11.314l45.255-45.255a8 8 0 0 1 11.313 0l125.158 125.158 195.162-195.162a8 8 0 0 1 11.313 0l45.255 45.255a8 8 0 0 1 0 11.314L489.697 751.456c-6.248 6.249-16.379 6.249-22.627 0L296.657 581.044zM225 199a8 8 0 0 1 8-8h560a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H233a8 8 0 0 1-8-8v-56zM352 72a8 8 0 0 1 8-8h303a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H360a8 8 0 0 1-8-8V72z" fill="#515151" p-id="1284"></path></svg>
)
class CouponList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  url_1:"", url_2:"",url_3:"",url_4:"",  url_5:"",  is_authorization_code:false, is_audit:false, page: 1, url: "", Visible: false, ItemData: "", closed: "" };

        this.columns = [
            {
                title: intl.get('common.table.id'),
                dataIndex: 'id',
                width: '3%',
                align: "center",
            },


            {
                title: intl.get("nav.goodsManagement.promotionalgoods_name"),
                width: '8%',
                // align: "center",
                render: (record) => {
                    return <div style={{ display: "flex", alignItems: "center" }}>

                        {

                             record.permanent_state === 1 &&  
                             <Icon type="stop" theme="filled" style={{ marginRight: "5px",color:"#58924d" }} />
                            

                        }

                        {
                            record.spu_id === 0 &&
                            <Icon type="shop" style={{ marginRight: "5px" }} />
                        }
                        <p style={{ margin: "0px" }}>{record.name}</p>
                    </div>
                }
            },

      

            {
                title: "盲盒价格",
                width: '8%',
                // align: "center",
                render: (record) => {
                    return <div style={{ display: "flex", alignItems: "center" }}> 
                        <p style={{ margin: "0px" }}>${record.price}</p>
                    </div>
                }
            },



             

            {/*
                title: "封面",
                width: '5%',
                align: "center",
                render: (record) => {
                    return (
                        <img style={{ width: "50px", height: "50px", objectFit: 'cover' }} src={record.image} alt="" />
                    )
                }
            */},
            

         

            {
                title: "开始时间",
                // dataIndex: "created_at",
                width: '5%',
                align: "center",
                render: (record) => {
                    let start_at = record.start_at
                    let end_at = record.end_at
                    let end_at_year = end_at.split(" ")
                    let end_at_time = new Date(end_at_year[0].split("/").reverse().join("/") + " " + end_at_year[1]).getTime()
                    let curDate = new Date(moment().tz('Australia/Sydney').format("YYYY/MM/DD HH:mm:ss")).getTime();
                    let isRed = end_at_time < curDate
                    return <div style={{ display: "flex", flexDirection: "column" }}>
                        <span>{start_at.substring(0, start_at.length - 8)}</span> 
                    </div>
                }
            },
            
 


            // {
            //     title: intl.get('nav.goodsManagement.promotionalgoods.OffTheShelf'),
            //     width: '5%',
            //     align: "center",
            //     render: (record) => {


            //         let curDate = new Date(moment().tz('Australia/Sydney').format("YYYY/MM/DD HH:mm:ss")).getTime();



            //         // let start_at = record.start_at
            //         // let end_at = record.end_at
            //         // let end_at_year = end_at.split(" ")
            //         // let end_at_time = new Date(end_at_year[0].split("/").reverse().join("/") + " " + end_at_year[1]).getTime() 
            //         // let isRed = end_at_time < curDate



 

            //         let thisState = false

                     
            //         // if (record.end_status) {
            //         //     thisState = true
            //         // } else if (record.permanent_state === 1) {
            //         //     thisState = true
            //         // } else if (isRed && record.state === 0) {
            //         //     thisState = true
            //         // } else if (record.stock === 0) {
            //         //     thisState = true
            //         // }
                     




            //          //判断可以随时上下架
            //         let start_at = record.start_at
            //         let start_at_year = start_at.split(" ")
            //         let start_at_time = new Date(start_at_year[0].split("/").reverse().join("/") + " " + start_at_year[1]).getTime()
                    
 
                  
            //         if(record.is_first_state == 1){ //如果已经自送上架了，则可以随时上下架
            //              thisState = false;
            //         }else{
            //             if(curDate < start_at_time){ //过了今天可以随时上下架，不管有没有自动上架
            //                 thisState = true;
            //             }else{
            //                 thisState = true;
            //             }

            //         }

                     

            //         //随时可以上下架，除了已终止的
            //          if(record.permanent_state != 1 ){
            //              return <Switch
            //                 checked={record.state === 1}
            //                 disabled={thisState}
            //                 onChange={() => this.onChangeState(record)} />

            //          }
                   
            //     }
            // },
            



             {
                title:  "显示",
                width: '5%',
                align: "center",
                render: (record) => {


                 if(record.is_generate == 1 ){
                        let disabled = false;
                        let checked = false;  
                        if(record.is_moon_show != 1){ 
                            checked = false; 
                        }else{
                            checked = true;   
                        }

                        return <Switch
                            checked={checked}
                            disabled={disabled}
                            onChange={() => this.onChangeMoonState(record)} /> 
                 }else{

                    let disabled = true;
                    let checked = false; 

                    return <Switch
                            checked={checked}
                            disabled={disabled}
                            onChange={() => this.onChangeMoonState(record)} />
                 }
                    

                    
                }
            },
            



            {
                title: "是否已生成",
                width: '8%',
                render: (record) => {
                    let cardtype; 
                    if (record.is_generate ==  0) {
                        cardtype = "未生成"
                    } else if (record.is_generate ==  1)  {
                        cardtype = "已生成" 
                    }  
                    return cardtype;
                } 
            },




 


            {
                title: <Tooltip title="如果该语言没有激活，则在当前语言环境下，不显示该条目" > 语言<Icon type="question-circle" style={{ marginLeft: "5px" }} /> </Tooltip>,
                width: '5%',
                align: "center",
                render: (record) => { 
                    return (
                        <Switch  
                            checked={record.disable_language == 0 } 
                            onChange={() => {
                            putCoupon({ "disable_language": record.disable_language === 1 ? "0" : "1" }, record.id)
                                .then(res => {
                                    this.HandleGetData(1)
                                }).catch(error => {
                                    // console.log(error.response, "11")
                                })
                        }} />
                    )
                }
            },




            {
                title: intl.get('category.list.sort'),
                dataIndex: 'sort',
                width: '3%',
                align: "center",
            },
            {
                title: intl.get('pack.form.opt'),
                width: '3%',
                align: "center",
                render: (record) => {

                    return <Popover
                        style={{ width: 500 }}
                        content={
                            <div style={{ display: "flex" }}>


                                {
                                    // record.is_first_state === 1 || record.is_lock === 1 ?
                                    record.sale_quantity > 0 || record.is_lock === 1 || record.permanent_state === 1 ?
                                        <Tooltip title={intl.get('home.table.operation.btn.view')}>
                                            <Button
                                                style={{ marginRight: "5px" }}
                                                shape="circle"
                                                icon="eye"
                                                onClick={() => {
                                                    this.props.history.push("/ViewCoupon/" + record.id)
                                                }} />
                                        </Tooltip> :
                                        <Tooltip title={intl.get('seat.table.btn.edit')}>
                                            <Button
                                                style={{ marginRight: "5px" }}
                                                shape="circle"
                                                icon="edit"
                                                onClick={() => {
                                                    this.props.history.push("/editCoupon/" + record.id)
                                                }} />
                                        </Tooltip>
                                }

 

                                <Tooltip title='生成Ticket'>
                                    <Button
                                        shape="circle"
                                        onClick={() => {
                                             
                                        }}>
                                        <Icon component={svgIcon} />
                                    </Button>
                                </Tooltip>


                                {
                                    record.permanent_state === 0 &&
                                    <Tooltip title={intl.get('orders.status.three')}>
                                        <Button
                                            style={{ marginLeft: "5px" }}
                                            shape="circle"
                                            icon="close"
                                            onClick={() => {
                                                this.setState({
                                                    Visible: true,
                                                    ItemData: record
                                                })
                                            }} />
                                    </Tooltip>
                                }


                            </div>
                        }
                        trigger="hover"
                    >
                        <Button
                            style={{ marginRight: "5px" }}
                            shape="circle"
                            icon="more"
                        />
                    </Popover>
                },
            },

        ];
    }


    async componentDidMount() {
        let spu_id = this.props.location.search && this.props.location.search.substring(8)
        console.log(spu_id)
        let shopData = await getPartner()
        let is_authorization_code = shopData.data.is_authorization_code === 0
        if (is_authorization_code) {
            this.columns.splice(4, 1)
        }
        if (spu_id) {
            this.setState({
                url: "&spu_id=" + spu_id
            }, () => {
                this.HandleGetData(1)
            })
        }
        this.setState({

            shopDataId: shopData.data.id,
            is_authorization_code:shopData.data.is_authorization_code,
            is_audit: shopData.data.is_coupon,

        }, () => {
            this.HandleGetData(1)
        })

    }

    async HandleGetData(page) {
        let res = await getBlindboxList(page, this.state.shopDataId, this.state.url)
        this.setState({
            data: res.data.data,
            meta: res.data.meta.pagination,
        })
    }




    async handleDelete(data) {
        await deleteCoupon(data.id)
        const dataSource = [...this.state.data];
        this.setState({ data: dataSource.filter(item => item.id !== data.id) });
    }



    onChangeMoonState = (item) => {
        let values = {}
        values.is_moon_show = item.is_moon_show == 1 ? "0" : "1"
        putCoupon(values, item.id).then(res => {
            this.HandleGetData()
        })
    }



    onChangeState = (item) => {
        let values = {}
        values.state = item.state === 1 ? "0" : "1"
        putCoupon(values, item.id).then(res => {
            this.HandleGetData()
        })
    }

    onChangeIsShow = (item) => {
        let values = {}
        values.is_show = item.is_show === 1 ? "0" : "1"
        putCoupon(values, item.id).then(res => {
            this.HandleGetData()
        })
    }

    handleOverOff = () => {
        let item = this.state.ItemData
        let values = {}
        values.spu_id = item.spu_id
        values.permanent_state = item.permanent_state === 1 ? "0" : "1"
        putCoupon(values, item.id).then(res => {
            this.setState({
                Visible: false,
                closed: ""
            });
            this.HandleGetData()
        })

    }

    handleCancel = () => {
        this.setState({
            Visible: false,
        });
    };



    // generateBlindbox = (item) => { 
    //     generateBlindbox(item.id).then(res => {
            
    //         message.success('生成成功')
    //         this.HandleGetData();


    //     })
    // }




    render() {
        let { meta, url, closed ,url_1,url_2,url_3,url_4 , url_5} = this.state
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0px" }}>
                    <div style={{ marginBottom: "5px" }}>
                        <Button
                            style={{ marginRight: "5px", backgroundColor: url === "" ? "#58924d" : "", color: url === "" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                            onClick={() => {
                                this.setState({
                                    url: "",
                                    url_1:"",
                                    url_2:"",
                                    url_3:"",
                                    url_4:"",
                                    
                                }, () => {
                                    this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            {intl.get('home.table.useStatus.all')}
                        </Button>


                        


                         <Button
                            style={{ marginRight: "5px", backgroundColor: url_1 === "&state=1" ? "#58924d" : "", color: url_1 === "&state=1" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                            onClick={() => {
                                this.setState({
                                    url: "&state=1" + url_2 +  url_3 + url_4,
                                    url_1:"&state=1",
                                     
                                }, () => {
                                    this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            已上架
                        </Button>


                         <Button
                            style={{ marginRight: "5px", backgroundColor: url_1 === "&state=0" ? "#58924d" : "", color: url_1 === "&state=0" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                            onClick={() => {
                                this.setState({
                                    url: "&state=0" + url_2 +  url_3 + url_4,
                                    url_1:"&state=0",
                                    
                                }, () => {
                                    this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            已下架
                        </Button>



                      


 

                    </div>

                    <div>
                    
                        
                        <Button
                            type="primary"
                            style={{ marginLeft: "10px" }}
                            onClick={() => this.props.history.push("/newBlindbox")}
                        >
                            {intl.get('nav.goodsManagement.promotionalgoods.coupon_new')}
                        </Button>
                    </div>
                </div>


                 

 

                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0px" }}>
                    <div style={{ marginBottom: "5px" }}>



                         <Button
                            style={{ marginRight: "5px", backgroundColor:  "#58924d" , color:  "#fff"   }}
                            onClick={() => {
                                this.setState({
                                    url: ""
                                }, () => {
                                    //this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            排序
                        </Button>



                         <Button
                            style={{ marginRight: "5px", backgroundColor: url_4 === "&orderby=1" ? "#58924d" : "", color: url_4 === "&orderby=1" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                            onClick={() => {
                                this.setState({
                                    url: "&orderby=1"+ url_1 +  url_2 + url_3,
                                    url_4:"&orderby=1"
                                }, () => {
                                    this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            创建时间
                        </Button>


                        <Button
                            style={{ marginRight: "5px", backgroundColor: url_4 === "&orderby=2" ? "#58924d" : "", color: url_4 === "&orderby=2" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                            onClick={() => {
                                this.setState({
                                     url: "&orderby=2"+ url_1 +  url_2 + url_3,
                                     url_4:"&orderby=2"
                                }, () => {
                                    this.HandleGetData(1, this.state.url)
                                })
                            }}>
                            开始时间
                        </Button> 
                </div>
                </div>



                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}> 
                        <div style={{ marginBottom: "5px" }}> 

                            <Button
                                style={{ marginRight: "5px", backgroundColor:  "#58924d"  , color: "#fff"   }}
                                onClick={() => {
                                    this.setState({
                                        url: ""
                                    }, () => {
                                        //this.HandleGetData(1, this.state.url)
                                    })
                                }}>
                                语言
                            </Button>

                             <Button
                                style={{ marginRight: "5px", backgroundColor: url_3 === "&is_disable_language=1" ? "#58924d" : "", color: url_3 === "&is_disable_language=1" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                                onClick={() => {
                                    this.setState({
                                        url: "&is_disable_language=1"  + url_1 +  url_2  , 
                                        url_3:"&is_disable_language=1",
                                         
                                    }, () => {
                                        this.HandleGetData(1, this.state.url)
                                    })
                                }}>
                                已激活
                            </Button>



                            <Button
                                style={{ marginRight: "5px", backgroundColor: url_3 === "&is_disable_language=0" ? "#58924d" : "", color: url_3 === "&is_disable_language=0" ? "#fff" : "rgba(0, 0, 0, 0.65)" }}
                                onClick={() => {
                                    this.setState({
                                        url: "&is_disable_language=0"    + url_1 +  url_2  , 
                                         url_3:"&is_disable_language=0",
                                        
                                    }, () => {
                                        this.HandleGetData(1, this.state.url)
                                    })
                                }}>
                                未激活
                            </Button> 
                        </div>
                    </div>





 



                <Table
                    rowKey={record => record.id}
                    dataSource={this.state.data}
                    columns={this.columns}
                    // scroll={{ x: 1000 }}
                    pagination={{
                        pageSize: meta && meta.per_page,
                        total: meta && meta.total
                    }}
                    onChange={(e) => {
                        this.HandleGetData(e.current)
                    }}
                    className="waperBox"
                />

                <Modal
                    title={intl.get('nav.goodsManagement.promotionalgoods.OffTheShelf_tips')}
                    visible={this.state.Visible}
                    onOk={() => {
                        if (closed === "confirm") {
                            this.handleOverOff()
                        } else {
                            message.error(intl.get("nav.goodsManagement.promotionalgoods.InputError"))
                        }
                    }}
                    onCancel={() => this.setState({ Visible: false, closed: "" })}
                    style={{ marginTop: "100px" }}
                >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <span style={{ marginBottom: "15px" }}>{intl.get("nav.goodsManagement.promotionalgoods.EnterClosed")}</span>
                        <Input
                            style={{ width: "300px", textAlign: 'center' }}
                            value={closed}
                            onChange={(e) => {
                                e.persist()
                                this.setState({
                                    closed: e.target.value.toLowerCase()
                                })
                            }} />
                    </div>

                </Modal>
            </div>
        );
    }
}

export default withRouter(Form.create()(CouponList))

